routes.$inject = ['$stateProvider']

export default function routes($stateProvider) {
  $stateProvider
    .state('shell.products', {
      url: '/products?page',
      template: require('./products.html'),
      controller: 'ProductsController',
      controllerAs: 'products',
      resolve: {
        $title: function() {
          return 'Products'
        }
      },
      params: {
        page: {
          value: '1',
          squash: true
        }
      }
    })
    .state('shell.productStore', {
      url: '/products/stores/:slug?page',
      template: require('./product-store.html'),
      controller: 'ProductStoreController',
      controllerAs: 'productStore',
      resolve: {
        productStore: ['ProductService', '$stateParams', function(ProductService, $stateParams) {
          return ProductService.getProductStore(sessionStorage.getItem('profileId'), $stateParams.slug)
        }],
        $title: ['productStore', function(productStore) {
          return productStore.data.store
        }]
      },
      params: {
        page: {
          value: '1',
          squash: true
        }
      }
    })
    .state('shell.productCategory', {
      url: '/products/categories/:slug?page',
      template: require('./product-category.html'),
      controller: 'ProductCategoryController',
      controllerAs: 'productCategory',
      resolve: {
        productCategory: ['ProductService', '$stateParams', function(ProductService, $stateParams) {
          return ProductService.getProductCategory(sessionStorage.getItem('profileId'), $stateParams.slug)
        }],
        $title: ['productCategory', function(productCategory) {
          return productCategory.data.category
        }]
      },
      params: {
        page: {
          value: '1',
          squash: true
        }
      }
    })
    .state('shell.product', {
      url: '/products/:slug',
      template: require('./product.html'),
      controller: 'ProductController',
      controllerAs: 'product',
      resolve: {
        product: ['ProductService', '$stateParams', function(ProductService, $stateParams) {
          return ProductService.getProduct(sessionStorage.getItem('profileId'), $stateParams.slug)
        }],
        $title: ['product', function(product) {
          return product.data.product
        }]
      }
    })
    .state('shell.newProduct', {
      url: '/products/new',
      template: require('./new-product.html'),
      controller: 'NewProductController',
      controllerAs: 'newProduct',
      resolve: {
        $title: function() {
          return 'New Product'
        }
      }
    })
}